import { Helmet } from 'react-helmet-async';
import { StructuredData } from '@/lib/jsonld-schema';

interface JsonLdProps {
  schema: StructuredData;
}

/**
 * Component to inject JSON-LD structured data into page head
 * Usage: <JsonLd schema={getServiceSchema({...})} />
 */
export const JsonLd = ({ schema }: JsonLdProps) => {
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export default JsonLd;
